module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAEeSURBVHjavNOxSsNQFAbgr0EU6qRgcXITxAcQpYsigtInEBfp6DtUxPgAvoGLIHRycRSKPoaCboKIiFAnUZekhNq0oUl61hzul/PfcyvtdluOquJrVFMgX22hVTYCp6OgIpCRUFHIUKhIJBWaGnOj5jCDxRQIwqxIgE00sIGVCMgyUQ9KQyrYxwmWc0QH4SBkHpfYK+iO/k2ygA5WC1yG6aAvoquCgTO0kpMcYXtAYxcPeMMHPvEdfVvC7jAgGdcsjhMN97jAHZ7wk3JQIwUJk+fFyCFqeEUTNzkiCvt+uIccREAdj0UCMVLDOnbKAOIXXcc1bssAYmQN52UBcVzVaJvGqU6WJQmiN/A7JtLN0hTgWck1MeRlEsh72cjfAHMuNce7USfYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back-btn.png
// module id = OqNe
// module chunks = 1